// @ts-nocheck
import React, { useEffect, useState, useRef, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import Grid from "@mui/material/Grid2";
import { Box, IconButton } from "@mui/material";
import { LiveIcon, CashIcon, NoBuyerIcon, ReportedIcon } from "../../components/Live";
import { useNavigate, useOutletContext } from "react-router-dom";
import { TbGavel } from "react-icons/tb";
import moment from "moment";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import { AppDispatch } from "../../redux/types";
import {
  addFavoriteProperty,
  getFavorityProperty,
  addSelectedId,
  removeSelectedId,
} from "../../redux/slice/favoritePropertySlice";

export default function Propertylist({ todaysProperties }) {
  const [countdowns, setCountdowns] = useState([]);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();
  const { investorId } = useSelector((state) => state?.user);

  const { calenderProperties } = useSelector(
    (state) => state.calenderProperties
  );

  const { favoriteProperties } = useSelector(
    (state) => state.favoriteProperties
  );

  const selectedIndex = useSelector(
    (state) => state.favoriteProperties.selectedIds
  );

  const isMobile = useOutletContext();
  const countdownInterval = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!calenderProperties || calenderProperties.length === 0) {
      return;
    }
    // Function to update the countdown for each property
    const updateCountdowns = () => {
      const newCountdowns =
        calenderProperties &&
        calenderProperties?.map((property, index) => {
          const auctionStartStr = moment
            .parseZone(property?.srpSaleDateTime)
            .format("YYYY-MM-DDTHH:mm:ssZ");
          const auctionStartDate = new Date(auctionStartStr);
          const currentDate = new Date();
          const timeDifference = auctionStartDate - currentDate;

          if (timeDifference <= 0) {
            return {
              index,
              days: 0,
              hours: 0,
              minutes: 0,
              seconds: 0,
            };
          }

          const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
          const hours = Math.floor(
            (timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          );
          const minutes = Math.floor(
            (timeDifference % (1000 * 60 * 60)) / (1000 * 60)
          );
          const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

          return {
            index,
            days,
            hours,
            minutes,
            seconds,
          };
        });

      setCountdowns((prevCountdowns) => {
        const updatedCountdowns = [...prevCountdowns];
        newCountdowns &&
          newCountdowns?.forEach(({ index, ...countdown }) => {
            updatedCountdowns[index] = countdown;
          });
        return updatedCountdowns;
      });
    };

    // Set an interval to update the countdown every second
    countdownInterval.current = setInterval(updateCountdowns, 1000);

    // Call updateCountdowns immediately to show the time remaining without waiting for the first interval
    updateCountdowns();

    // Cleanup function to clear the interval when the component is unmounted
    return () => clearInterval(countdownInterval.current);
  }, [calenderProperties]);

  function formatToDollar(amount) {
    return new Intl.NumberFormat("en-US", {
      style: "decimal",
      minimumFractionDigits: 0, // No decimal places
      maximumFractionDigits: 0,
    }).format(amount);
  }

  const groupedByTime = useMemo(() => {
    return todaysProperties.reduce((acc, property) => {
      // If saleTime exists, format it as a time string
      if (property?.srpSaleDateTime) {
        const formattedTime = moment.parseZone(property?.srpSaleDateTime).format("hh:mm A"); // Format time as 'hh:mm AM/PM'
        // If the time group doesn't exist, create it
        if (!acc[formattedTime]) {
          acc[formattedTime] = [];
        }

        // Push the property into the correct time group
        acc[formattedTime].push(property);
      }

      return acc;
    }, {});
  }, [todaysProperties])
  const handleViewDetails = (property) => {
    const remoteflag = property.isRemoteBiddingEligible;
    navigate(`/auctionPage/${property?.propertyId}`, { state: { remoteflag } });
  };

  useEffect(() => {
    if (!calenderProperties) {
      return
    }
    const fetchfavproperties = async () => {
      const favproperties = await dispatch(
        getFavorityProperty(investorId)
      ).unwrap();
    };
    fetchfavproperties();
  }, [calenderProperties]);

  const handleAddFavoriteProperties = async (propertyId, index) => {
    setError(null);

    const requiredData = {
      investorId,
      propertyId,
      isRemoved: selectedIndex.includes(propertyId), // The toggled value for removal
    };

    try {
      // Dispatch action to add/remove from favorites
      if (selectedIndex.includes(propertyId)) {
        dispatch(removeSelectedId(propertyId));
      } else {
        dispatch(addSelectedId(propertyId));
      }

      await dispatch(addFavoriteProperty(requiredData));

      // Optionally, you may want to handle the updated list in your UI here
    } catch (error) {
      // Handle any errors
      setError(error);
    }
  };
  return (
    <div>
      {Object.keys(groupedByTime)
        .sort((a, b) => moment(a, "hh:mm A").diff(moment(b, "hh:mm A")))
        .map((time, index) => {
        const propertiesForTime = groupedByTime[time];
        return (
          <div key={index}>
            <div className="mt-4">
              <span className="text-[22px] font-semibold leading-[33px]">
                {moment(time, "hh:mm A").format("hh:mm A")}{" "}
                {/* Corrected moment formatting */}
              </span>
            </div>
            {propertiesForTime.map((property, index) => {
              // Retrieve the countdown for the current property
              const countdown = countdowns.find(
                (countdown) => countdown.index === index
              );

              return (
                <div
                  key={index}
                  className={`bg-white p-3 flex w-full ${isMobile ? "mt-3" : "mt-4"
                    } h-auto`}
                  style={{ boxShadow: "0px 0px 3px 2px rgba(0,0,0,.1)" }}
                >
                  {/* Property Info Section */}
                  <Grid container sx={{ width: "100%" }}>
                    <Grid size={{ xs: 7, sm: "auto" }}>
                      <p className="text-lg sm:text-xl">
                        <span className="text-[20px] font-semibold leading-[30px]">
                          $
                          {property?.openingBidAmount === null || property?.openingBidAmount === 0 || property?.openingBidAmount === 0.00
                            ? (property?.reserveValue > 0 ? formatToDollar(property?.reserveValue) : 0)

                            : formatToDollar(
                              property?.openingBidAmount
                            )}
                        </span>
                        <span className="text-[15px] font-normal leading-[21px]">
                          {" "}
                          Est. Opening Bid
                        </span>
                      </p>
                      <p className="mt-1 sm:mt-2 sm:font-light text-[15px] sm:text-base whitespace-nowrap">
                        {property?.isRemoteBiddingEligible
                          ? "Foreclosure Trustee - Remote bid enabled"
                          : "Foreclosure Trustee"}
                      </p>
                      <p className="mt-1 sm:mt-2 text-[18px] sm:text-base font-medium text-gray-700 whitespace-nowrap">
                        {property?.addressLine1}{" "}
                        {property?.addressLine2}
                      </p>

                      {/* Detailed Info Section */}
                      {!isMobile && (
                        <>
                          <div className="w-3/5 mt-2">
                            {countdown?.days === 0 &&
                              countdown?.hours === 0 &&
                              countdown?.minutes === 0 &&
                              countdown?.seconds === 0 ? (
                              <div className="w-5/5">
                                <LiveIcon />
                              </div>
                            ) : (
                              <>
                                {moment
                                  .parseZone(
                                    property?.srpSaleDateTime
                                  )
                                  .format("MMM D, hh:mm A")}
                              </>
                            )}
                          </div>
                        </>
                      )}
                    </Grid>

                    {/* Right Column */}
                    <Grid
                      size={{ xs: 12, sm: "auto" }}
                      display={"flex"}
                      ml={{ sm: "auto" }}
                      justifyContent={"space-between"}
                      alignItems={{ sm: "flex-end" }}
                      rowGap={{ xs: 1 }}
                      flexDirection={"column"}
                    >
                      {isMobile && (
                        <>
                          <div className="flex items-center space-x-1 mt-1">
                            <div className="flex items-center ">
                              <span>
                                {property?.county} County
                              </span>
                            </div>
                          </div>
                        </>
                      )}

                      <div
                        className={`flex space-x-3 items-start ${isMobile ? "justify-start" : "justify-center"
                          } sm:items-end md:items-start`}
                      >
                        {property?.cashOnlyTag == "Cash Only" ? <CashIcon /> : ""}
                        {property?.reportedVacant == "YN_Y" ? <ReportedIcon /> : ""}
                        {!isMobile && property?.isProxyBid && (
                          <div
                            style={{
                              backgroundColor: "#12B28C",
                              borderRadius: "50%",
                              width: 30,
                              height: 30,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center"
                            }}
                          >
                            <TbGavel size={20} color="white" />
                          </div>
                        )}
                      </div>

                      {/* Mobile Version */}

                      <div className="flex justify-between">
                        {isMobile && <LiveIcon />}
                        <div className="flex items-center justify-center gap-0 sm:gap-2">
                          <IconButton
                            onClick={() =>
                              handleAddFavoriteProperties(
                                property?.propertyId,
                                index
                              )
                            }
                            style={{
                              cursor: "pointer",
                            }}
                            aria-label={
                              !selectedIndex.includes(property?.propertyId)
                                ? "Add to favorites"
                                : "Remove from favorites"
                            }
                          >
                            {/* Conditional rendering of the icon */}
                            {!selectedIndex.includes(
                              property?.propertyId
                            ) ? (
                              <svg
                                stroke="#FF5C39"
                                fill="#FF5C39"
                                stroke-width="0"
                                viewBox="0 0 1024 1024"
                                height="1em"
                                width="1em"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path d="M923 283.6a260.04 260.04 0 0 0-56.9-82.8 264.4 264.4 0 0 0-84-55.5A265.34 265.34 0 0 0 679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 0 0-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9zM512 814.8S156 586.7 156 385.5C156 283.6 240.3 201 344.3 201c73.1 0 136.5 40.8 167.7 100.4C543.2 241.8 606.6 201 679.7 201c104 0 188.3 82.6 188.3 184.5 0 201.2-356 429.3-356 429.3z"></path>
                              </svg>
                            ) : (
                              <svg
                                stroke="#FF5C39"
                                fill="#FF5C39"
                                stroke-width="0"
                                viewBox="0 0 1024 1024"
                                height="1em"
                                width="1em"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path d="M923 283.6a260.04 260.04 0 0 0-56.9-82.8 264.4 264.4 0 0 0-84-55.5A265.34 265.34 0 0 0 679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 0 0-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9z"></path>
                              </svg>
                            )}
                          </IconButton>
                          <button
                            className="text-white rounded-lg bg-[#FF5C39] px-[16px] py-[10px]"
                            onClick={() => handleViewDetails(property)}
                            aria-label="View details of the property"
                          >
                            View Details
                          </button>
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
}
